// import menu from '../constants/menu.json';
import adminMenu from "../constants/adminMenu.json";
import taskReport from "../constants/taskReport.json";
import SubMenu from "../components/SubMenu";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toggleSidebar } from "../redux/authSlice";
import React, { useEffect, useState } from "react";
import { getUserData } from "../utils/localStorage";

const SideBar = () => {
  const dispatch = useDispatch();
  const handleToggleSidebar = () => dispatch(toggleSidebar());

  const { userProfileData } = getUserData();

  const role = userProfileData?.role;

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li
          className="nav-item card"
          sx={{ color: "#012970" }}
          onClick={handleToggleSidebar}
        >
          <Link className={`nav-link collapsed`} to={"/"}>
            <i className="bi bi-house-door" />
            <span>{"Home"}</span>
          </Link>
        </li>

        {(role === "ROLE_SUPER_ADMIN" || role === "ROLE_ADMIN") &&
          <>
            <li
              className="nav-item card"
              sx={{ color: "#012970" }}
              onClick={handleToggleSidebar}
            >
              <Link className={`nav-link collapsed`} to={"masters"}>
              <i className="bi bi-gear" />
                <span>{"Masters"}</span>
              </Link>
            </li>
            <li
              className="nav-item card"
              sx={{ color: "#012970" }}
              onClick={handleToggleSidebar}
            >
            <Link className={`nav-link collapsed`} to={"lead/list"}>
              <i className="bi bi-person-lines-fill" />
                <span>{"Leads"}</span>
              </Link>
            </li>
          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"admin-process-fee/list"}>
              <i className="bi bi-currency-rupee" />
              <span>{"Fees"}</span>
            </Link>
          </li>

          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"retail-pipeline"}>
              <i className="bi bi-shop" />
              <span>{"Retail"}</span>
            </Link>
          </li>

          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"wholesale-pipeline"}>
              <i className="bi bi-building" />
              <span>{"Wholesale"}</span>
            </Link>
          </li>

          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"operation-department"}>
              <i className="bi bi-gear-wide-connected" />
              <span>{"Operation"}</span>
            </Link>
          </li>


          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"telecaller-department"}>
              <i className="bi bi-telephone" />
              <span>{"TeleCaller"}</span>
            </Link>
          </li>

          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"project_report_and_cma_report"}>
              <i className="bi bi-file-earmark-text" />
              <span>{"Project Report"}</span>
            </Link>
          </li>

          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"course_report"}>
              <i className="bi bi-book" />
              <span>{"Course"}</span>
            </Link>
          </li>

          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"software"}>
              <i className="bi bi-code-slash" />
              <span>{"Software"}</span>
            </Link>
          </li>

          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"subsidy"}>
              <i className="bi bi-wallet2" />
              <span>{"Subsidy"}</span>
            </Link>
          </li>

          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"nivesh4u"}>
              <i className="bi bi-graph-up-arrow" />
              <span>{"Nivesh4u"}</span>
            </Link>
          </li>
          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"cfomsme"}>
              <i className="bi bi-briefcase" />
              <span>{"CFOMSME"}</span>
            </Link>
          </li>
          </>
        }

        {(role === "ROLE_TELECALLER" || role === "ROLE_SUPER_TELECALLER") &&
          <>
          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"lead/list"}>
              <i className={"bi bi-house"} />
              <span>{"Leads"}</span>
            </Link>
          </li>
          </>
        }

        {(role === "ROLE_OPERATION") &&
          <>
          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"operation-lead/list"}>
              <i className={"bi bi-house"} />
              <span>{"Leads"}</span>
            </Link>
          </li>
          </>
        }

      </ul>
    </aside>
  );
};
export default SideBar;
